var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"width":"90px"},attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }